"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuUp = _interopRequireDefault(require("mdi-material-ui/MenuUp"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    summaryContent: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      border: 'none',
      '&$expanded': {
        margin: 'initial'
      },
      maxWidth: '100%'
    },
    summaryRoot: {
      borderBottom: '1px solid #E3E6E7',
      height: 48,
      minHeight: 48,
      padding: 0,
      '&$expanded': {
        minHeight: 48
      }
    },
    expanded: {},
    collapseDisable: {
      cursor: 'default',
      pointerEvents: 'none'
    },
    heading: (0, _objectSpread2.default)({}, theme.typography.h3, {
      height: 48,
      display: 'flex',
      alignItems: 'center',
      fontWeight: theme.typography.fontWeightMedium
    }),
    secondaryHeading: (0, _objectSpread2.default)({}, theme.typography.caption, {
      color: theme.palette.text.secondary,
      height: 48,
      display: 'flex',
      alignItems: 'center',
      '&>svg': {
        fontSize: 18,
        marginLeft: 3
      },
      '&>button': {
        marginRight: -12
      },
      marginLeft: 24,
      overflow: 'hidden'
    }),
    secondaryHeadingSpan: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    panel: {
      boxShadow: 'none',
      border: 'none'
    },
    panelDetails: {
      padding: '8px 0 24px 0'
    },
    panelDetailsExited: {
      display: 'none'
    },
    disabledPanel: {
      backgroundColor: '#ffffff',
      opacity: 1
    },
    expandIcon: {
      width: 24,
      height: 24,
      right: 0
    }
  };
});

/**
 * HiExpansionPanel
 */
var _ref = /*#__PURE__*/_react.default.createElement(_MenuUp.default, null);
function HiExpansionPanel(props) {
  var disabled = props.disabled,
    heading = props.heading,
    secondaryHeading = props.secondaryHeading,
    secondaryHeadingDisabled = props.secondaryHeadingDisabled,
    secondaryHeadingIcon = props.secondaryHeadingIcon,
    collapseDisable = props.collapseDisable,
    children = props.children,
    expanded = props.expanded,
    TransitionProps = props.TransitionProps,
    others = (0, _objectWithoutProperties2.default)(props, ["disabled", "heading", "secondaryHeading", "secondaryHeadingDisabled", "secondaryHeadingIcon", "collapseDisable", "children", "expanded", "TransitionProps"]);
  var classes = useStyles(props);
  var _useState = (0, _react.useState)(!collapseDisable && !expanded),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    panelDetailsExited = _useState2[0],
    setPanelDetailsExited = _useState2[1];
  var effectiveDisabled = disabled || !children;
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, (0, _extends2.default)({
    disabled: effectiveDisabled,
    expanded: collapseDisable || expanded,
    TransitionProps: (0, _objectSpread2.default)({
      onExited: function onExited() {
        return setPanelDetailsExited(true);
      },
      onEnter: function onEnter() {
        return setPanelDetailsExited(false);
      }
    }, TransitionProps)
  }, others, {
    classes: {
      root: classes.panel,
      disabled: classes.disabledPanel
    }
  }), /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, {
    classes: {
      root: classes.summaryRoot,
      content: classes.summaryContent,
      expanded: classes.expanded,
      expandIcon: classes.expandIcon
    },
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.collapseDisable, collapseDisable)),
    expandIcon: !collapseDisable && _ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.heading
  }, heading), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.secondaryHeading
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.secondaryHeadingSpan
  }, !effectiveDisabled ? secondaryHeading : secondaryHeadingDisabled), secondaryHeadingIcon)), !!children && /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, {
    className: (0, _classnames.default)(classes.panelDetails, (0, _defineProperty2.default)({}, classes.panelDetailsExited, panelDetailsExited))
  }, children));
}
HiExpansionPanel.defaultProps = {
  disabled: false,
  secondaryHeading: '',
  secondaryHeadingIcon: '',
  secondaryHeadingDisabled: ''
};
var _default = exports.default = HiExpansionPanel;